import { Modal as ResponsiveModal } from 'react-responsive-modal';
import { ReactNode } from 'react';
import { DividerLine } from '../dividerLine';
import styles from './style.module.scss';
import Div from '@/shared/Div';

interface ModalProps {
  id?: string;
  title?: string;
  titleStyle?: string;
  headerStyle?: string;
  closeButtonStyle?: string;
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  classNames?: string;
  showDividerLine?: boolean;
  showCloseButton?: boolean;
  showHeader?: boolean;
  renderFooter?: any;
  renderHeader?: any;
  modalClassNames?: any;
}

const Modal = ({
  id,
  title,
  titleStyle,
  headerStyle,
  closeButtonStyle,
  open,
  onClose,
  children,
  classNames,
  showDividerLine,
  showCloseButton,
  showHeader,
  renderFooter,
  renderHeader,
  modalClassNames,
}: ModalProps) => {
  return open ? (
    <ResponsiveModal
      blockScroll={false}
      modalId={id}
      open={open}
      onClose={onClose}
      center
      showCloseIcon={showCloseButton ? showCloseButton : false}
      classNames={{
        modal:
          modalClassNames?.modal ??
          '!p-0 !m-0 !align-bottom md:!align-middle max-h-[90%] min-w-[350px] max-w-[100%] w-[100%] md:w-[auto] md:max-w-2xl rounded-t-cs md:rounded-cs',
        root: styles.container,
      }}
    >
      {showHeader === false ? (
        <></>
      ) : (
        <Div
          className={`flex justify-between items-center sticky p-4 top-0 z-10  ${styles.header} ${headerStyle}`}
        >
          {title && (
            <>
              <header className="text-xl font-bold w-full">
                <h2 className={titleStyle}>{title}</h2>
              </header>
              {showDividerLine && <DividerLine variant="solid" orientation="horizontal" />}
            </>
          )}
          {showCloseButton === false ? (
            <></>
          ) : (
            <button
              className={closeButtonStyle}
              onClick={() => onClose()}
              data-testid="close-button"
            >
              <svg width="28" height="28" viewBox="0 0 36 36" data-testid="close-icon" className="">
                <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path>
              </svg>
            </button>
          )}
        </Div>
      )}
      {renderHeader && renderHeader()}
      <main className={`${classNames}`}>{children}</main>

      {renderFooter && renderFooter()}
    </ResponsiveModal>
  ) : null;
};

Modal.defaultProps = {
  id: 'modal',
  title: '',
  children: undefined,
  open: false,
  onClose: () => {},
  classNames: '',
};

export default Modal;
